export const transferLoaderTranslationKeys = {
  explanation: 'transfer-partner.loader-text',
}
